import { NavigateFunction, useNavigate } from 'react-router-dom';

export let routerNavigate: NavigateFunction;

export const ExposeRouterNavigate = () => {
  routerNavigate = useNavigate();

  return null;
};
